import React, { useEffect, useState } from 'react';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import Lightbox from 'react-image-lightbox';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import Box from '@mui/material/Box';
import ImageList from '@mui/material/ImageList';
import ImageListItem from '@mui/material/ImageListItem';
import Button from '@mui/material/Button';

import Grid from '@mui/material/Grid';
import Main from 'layouts/Main';

// import p1 from 'assests/Photos/Clubs/ReadingClub/2024/ReadingDay/1.jpg';

// import p1 from 'assests/Photos/Clubs/ReadingClub/2024/ReadingDay/1.jpg';

// import p2 from 'assests/Photos/Clubs/ReadingClub/2024/ReadingDay/2.jpg';
// import p3 from 'assests/Photos/Clubs/ReadingClub/2024/ReadingDay/3.jpg';
// import p4 from 'assests/Photos/Clubs/ReadingClub/2024/ReadingDay/4.jpg';

// import p5 from 'assests/Photos/SchoolProgram/2023/RepublicDay/5.jpg';
// import p6 from 'assests/Photos/SchoolProgram/2023/RepublicDay/6.jpg';
// import p7 from 'assests/Photos/SchoolProgram/2023/RepublicDay/7.jpg';
// import p8 from 'assests/Photos/SchoolProgram/2023/RepublicDay/8.jpg';
// import p9 from 'assests/Photos/SchoolProgram/2023/RepublicDay/9.jpg';
// import p10 from 'assests/Photos/SchoolProgram/2023/RepublicDay/10.jpg';


import { Typography } from '@mui/material';
import Container from 'components/Container';
import { Sidebar2023 } from 'views/SchoolProgram2023/components';
import Sidebar2024 from '../ReadingClub/components/Sidebar2024';
import ReadingClubSidebar2025 from '../ReadingClubSidebar2025';
import Archive2024 from '../ReadingClubSidebar2025/Archive2024';

const ReadingDay2025 = () => {
    const theme = useTheme();
    const [currentImage, setCurrentImage] = useState(0);
    const [viewerIsOpen, setViewerIsOpen] = useState(false);

    const openLightbox = (index) => {
        setCurrentImage(index);
        setViewerIsOpen(true);
    };

    const closeLightbox = () => {
        setCurrentImage(0);
        setViewerIsOpen(false);
    };

    const isMd = useMediaQuery(theme.breakpoints.up('md'), {
        defaultMatches: true,
    });

    

    const [config, setConfig] = useState({ base_image_url_2025: '' });
    useEffect(() => {
      fetch('/config.json')
        .then(response => response.json())
        .then(data => setConfig(data))
        .catch(error => console.error('Error fetching config:', error));
    }, []);
    
    const p1 = `${config.base_image_url_2025}/home/events-activities/club/ReadingClub/ReadingDay/1.webp`;
    const p2 = `${config.base_image_url_2025}/home/events-activities/club/ReadingClub/ReadingDay/2.webp`;
    const p3 = `${config.base_image_url_2025}/home/events-activities/club/ReadingClub/ReadingDay/3.webp`;
    const p4 = `${config.base_image_url_2025}/home/events-activities/club/ReadingClub/ReadingDay/4.webp`;
    

    const photos = [
        {
            src: p1,
            source: p1,
            rows: 1,
            cols: 1,
        },
        {
            src: p2,
            source: p2,
            rows: 1,
            cols: 1,
        },
        {
            src: p3,
            source: p3,
            rows: 1,
            cols: 1,
        }, 
        {
            src: p4,
            source: p4,
            rows: 1,
            cols: 1,
        },
      
        
      
       
    ];

    return (
        <Main>
            <Container>
                <Grid container spacing={4}>
                    <Grid item xs={12} md={8}>
                        <Box>

                            <Box >
                                <Typography variant='h4' align='center'>
                                READING DAY	
                                </Typography>
                                <Typography
                                    fontSize="x-small"
                                ><br /><br />
                               Date: 19 June 2025
                                </Typography>

                                <br />
                                <Typography variant={'subtitle1'} align={'justify'}>
                               ‘National Reading Day’ is celebrated on 19 June every year, to commemorate the death anniversary of Shri P.N. Panicker who is known as the Father of Library Movement in India. The Department of Library organised an event called ‘DEAR-Drop Everything and Read’ on Monday, 19 June 2025. Students of Class 4 formed the word ‘NPS’ and read a story from their English textbooks. Two students from Class 5 and one student from Class 11 highlighted the importance of reading and pledged to inculcate the habit of reading in their lives.
                              <br></br>
                              The students actively participated in various activities like Newspaper Reading, Poster Designing, Slogan Writing, Quiz etc. which helped them to foster love for books.
                              <br></br>
                              The Principal, Ms Sheeja Manoj highlighted the benefits of reading and encouraged students to make it as a daily habit, promoting a culture of literacy and lifelong learning. 
                              <br></br>
                                </Typography>
                            </Box>
                            <Typography
                                variant={'h6'}
                                color={'primary'}
                                align={'center'}
                                fontWeight={'normal'}
                            ><br />
                                “The more that you read, the more things you will know. The more that you learn, the more places you'll go”-Dr Seuss

                                <br />
                            </Typography>

                            <Box>
                                <ImageList
                                    variant="quilted"
                                    cols={2}
                                    rowHeight={isMd ? 200 : 100}
                                    gap={isMd ? 16 : 4}
                                >
                                    {photos.map((item, i) => (
                                        <ImageListItem key={i} cols={item.cols} rows={item.rows}>
                                            <LazyLoadImage
                                                height={'100%'}
                                                width={'100%'}
                                                src={item.src}
                                                alt="..."
                                                effect="blur"
                                                onClick={() => openLightbox(i)}
                                                style={{
                                                    objectFit: 'cover',
                                                    filter:
                                                        theme.palette.mode === 'dark' ? 'brightness(0.7)' : 'none',
                                                    cursor: 'poiner',
                                                    borderRadius: 8,
                                                }}
                                            />
                                        </ImageListItem>
                                    ))}
                                </ImageList>
                            </Box>
                            {viewerIsOpen && (
                                <Lightbox
                                    mainSrc={photos[currentImage].src}
                                    nextSrc={photos[(currentImage + 1) % photos.length].src}
                                    prevSrc={
                                        photos[(currentImage + photos.length - 1) % photos.length].src
                                    }
                                    onCloseRequest={() => closeLightbox()}
                                    onMovePrevRequest={() =>
                                        setCurrentImage((currentImage + photos.length - 1) % photos.length)
                                    }
                                    onMoveNextRequest={() =>
                                        setCurrentImage((currentImage + 1) % photos.length)
                                    }
                                    reactModalStyle={{ overlay: { zIndex: 1500 } }}
                                />
                            )}
                        </Box>
                    </Grid>
                    <Grid item xs={12} md={4}>
                    <Box marginBottom={4}>
                            <ReadingClubSidebar2025/>
                        </Box> 
                        <Box marginBottom={4}>
                            <Archive2024/>
                        </Box>
                    </Grid>
                </Grid>
            </Container>
        </Main>

    );
};

export default ReadingDay2025;